import Request from '@/utils/request'

export function normalDayClaim(taskId) {
  return Request({
    url: `/api/v2/app/activity/eid/daily/claim?taskId=${taskId}`,
    method: 'post',
  })
}

export function normalDaySign() {
  return Request({
    url: '/api/v2/app/activity/eid/daily/sign',
    method: 'post',
  })
}

export function normalActBaseInfo() {
  return Request({
    url: '/api/v2/app/activity/eid/home',
    method: 'get',
  })
}

export function normalMilesClaim() {
  return Request({
    url: '/api/v2/app/activity/eid/milestone/claim',
    method: 'post',
  })
}

export function normalActRank() {
  return Request({
    url: '/api/v2/app/activity/eid/rank',
    method: 'get',
  })
}

export function normalActHistory(params) {
  return Request({
    url: '/api/v2/app/activity/eid/wheel/reward/history',
    method: 'get',
    params,
  })
}

export function normalActSpin(params) {
  return Request({
    url: '/api/v2/app/activity/eid/wheel/spin',
    method: 'get',
    params,
  })
}
